import React from 'react';
import Footer from './Parts/GeneralParts/Footer';
import BannerPrincipal from './Parts/GeneralParts/BannerPrincipal';
import DescripcionStandard from './Parts/DescripcionStandard';
import SolicitarEmpleo from './Parts/GeneralParts/SolicitarEmpleo';
import SlideClientes from './Parts/GeneralParts/SlideClientes';
import listadoClientes from './Parts/infoDemoClientes';

class Servicios extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            nombre:"Calibración de Equipos",
            descripcion:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            imgBannerPrincipal:[
                {
                    alt:"first_slide",
                    url:"./img/img_servicios.jpg"
                }
            ],
            imagenesClientes:listadoClientes
        }
    }


    render() {
        return (
            <div className="contenedor_contenido_app">
                <BannerPrincipal imgBannerPrincipal={this.state.imgBannerPrincipal} />
                <DescripcionStandard descriptionObject={this.state} />
                <SlideClientes imagenesClientes={this.state.imagenesClientes} />
                <SolicitarEmpleo />
                <Footer />
            </div>
        )
    }
}

export default Servicios;